import React, { useEffect, useState } from 'react';
import axios from 'axios';
import '../styles/GlobalStyles.css';

const JobsList = () => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/institutionfilter/getMyJobs`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        });
        const jobArray = response?.data?.data || [];
        // Filter out jobs that have been reposted (show only the latest version)
        const validJobs = jobArray.filter(job => !job.reposted_as_id);
        setJobs(validJobs);
      } catch (err) {
        console.error(err);
        setError('Failed to fetch job listings');
      } finally {
        setLoading(false);
      }
    };

    fetchJobs();
  }, []);

  if (loading) return <div className="py-8 text-center">Loading...</div>;
  if (error) return <div className="py-8 text-center text-red-500">{error}</div>;

  return (
    <div className="global-font w-full px-2 space-y-6 sm:px-0">
      <h2 className="mb-6 text-2xl font-semibold text-gray-800">Job Listings</h2>
      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2">
        {jobs.map((job) => (
          <div key={job._id} className="profile-card flex flex-col justify-between p-5 transition hover:shadow-md relative">
            <div className="absolute top-4 right-4">
              <span className={`px-2 py-1 text-xs font-semibold rounded-full ${job.repost_of_id
                ? 'bg-green-100 text-green-700'
                : ((job.closing_date && new Date(job.closing_date) < new Date()) || job.status !== 'open'
                  ? 'bg-red-100 text-red-700'
                  : 'bg-green-100 text-green-700')
                }`}>
                {job.repost_of_id
                  ? 'Reposted'
                  : ((job.closing_date && new Date(job.closing_date) < new Date()) ? 'Closed' : (job.status === 'open' ? 'Open' : 'Closed'))
                }
              </span>
            </div>
            <div className="mt-6"> {/* Added margin top to prevent overlap with absolute badge */}
              <h3 className="text-xl font-semibold text-blue-700">{job.title}</h3>
              <p className="mt-1 text-sm text-gray-600">{job.department}</p>
              <p className="text-sm text-gray-500">{job.experience_level}</p>
              <p className="mt-2 text-sm text-gray-700">
                {job.description?.slice(0, 120)}{job.description?.length > 120 ? '...' : ''}
              </p>
            </div>
            <div className="flex items-center justify-between mt-4">
              <span className="text-xs text-gray-500">
                {job.repost_of_id ? 'Reposted on ' : ''}{new Date(job.posted_date).toLocaleDateString()}
              </span>
              {console.log(job.address.city)}
              <a href={`/view-job/${job._id}`} className="text-sm text-blue-500 hover:underline">
                View Details
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default JobsList;
